export default __webpack_public_path__ + "static/media/balance.96c695cd.png";